import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSignReceiptCommand } from './serialize';

/** POST `…/{id}/establish`：DRAFT → ESTABLISHED。 */
export async function establishSignReceipt(id, payload) {
  const { data: raw } = await request.post(
    `/aftersales/sign-receipt/${id}/establish`,
    serializeSignReceiptCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
